import React from "react";
import PropTypes from "prop-types";
import { TextDisplay } from "..";
import styles from "./styles/phone-display.css.js";
import withStyles from "components/with-styles";

const PhoneDisplay = ({ phone, classes, ...props }) => {
  if (!phone) {
    return null;
  }

  return (
    <TextDisplay icon="phone" className={classes.phoneDisplay} {...props}>
      {phone}
    </TextDisplay>
  );
};

PhoneDisplay.propTypes = {
  /**
   * Teléfono a mostrar
   **/
  phone: PropTypes.string,
};

export default withStyles(styles)(PhoneDisplay);
